export const BONUS_DAYS_CAMPAIGNS = 'bonus_days';
